/**
 * Colores de estado unificados para toda la plataforma.
 * Alineado con designTokens.js
 */

import { colors } from "./designTokens";

export const STATUS_COLORS = {
  // Estados de agentes de marketing (Equipo de Marketing Agéntico)
  trabajando: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  esperando_ok: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  libre: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  presupuesto_agotado: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },

  // Estados del Gestor de Pauta (pauta_actions)
  aplicado: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  dry_run: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  rechazado_por_limite: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  descartado: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  error: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },

  // Estados de incidencias/tareas
  reportada: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  pendiente: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  abierta: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  en_proceso: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  respondida: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  resuelta: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  cancelada: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },
  cerrada: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },

  // Estados de pago
  pagado: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  pagada: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  impago: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },
  pendiente_verificacion: { bg: "#f3e8ff", text: "#6b21a8", border: "#d8b4fe" },
  aprobado: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  aprobada: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  rechazado: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },
  rechazada: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },

  // Estado de cuenta por unidad (BuildingAccountView)
  al_dia: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  en_deuda: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },

  // Estados de obras/proyectos
  planificado: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  en_progreso: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  en_curso: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  finalizado: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  programada: { bg: "#f3e8ff", text: "#6b21a8", border: "#d8b4fe" },
  pausado: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },

  // Estados de multas
  activa: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },
  anulada: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  incluida_en_cierre: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },

  // Estados de prospección (régimen PH del padrón + Vivienda Promovida)
  ph_en_tramite: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  ph_incorporado: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  comun: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  vivienda_promovida: { bg: "#f3e8ff", text: "#6b21a8", border: "#d8b4fe" },

  // Estados del CRM comercial (pipeline de prospección)
  sin_contactar: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  contactado: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  en_conversacion: { bg: colors.primaryLighter, text: colors.primary, border: colors.primaryLight },
  reunion: { bg: "#f3e8ff", text: "#6b21a8", border: "#d8b4fe" },
  propuesta: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  ganado: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  perdido: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },
  descartado: { bg: colors.gray100, text: colors.gray400, border: colors.gray200 },

  // Estados de reuniones/revisiones
  completada: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },

  // Roles de usuario
  propietario: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  inquilino: { bg: "#fce7f3", text: "#be185d", border: "#f9a8d4" },

  // Prioridades
  alta: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },
  media: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  baja: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },

  // Turnos
  regular: { bg: colors.primaryLighter, text: colors.primary, border: colors.primaryLight },
  extra: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  feriado: { bg: "#fce7f3", text: "#be185d", border: "#f9a8d4" },

  // Asistencia
  presente: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  ausente: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },

  // Liquidaciones
  borrador: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  emitido: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },

  // Semáforo operativo de edificios (HomeAdmin)
  critico: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },
  atencion: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  normal: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },

  // Invitaciones de residentes
  enviada: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },

  // Estado de implementación de procesos (mapa de procesos / Super Admin)
  completo: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  parcial: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  inferido: { bg: colors.gray100, text: colors.gray600, border: colors.gray300 },

  // Estados de cuenta de residente (computeAccountState)
  cuenta_activa: {
    bg: colors.successLight,
    text: colors.successDark,
    border: "#86efac",
  },
  cuenta_invitada: {
    bg: colors.infoLight,
    text: colors.infoDark,
    border: "#93c5fd",
  },
  cuenta_vencida: {
    bg: colors.warningLight,
    text: colors.warningDark,
    border: "#fcd34d",
  },
  cuenta_sin_enviar: {
    bg: colors.gray100,
    text: colors.gray600,
    border: colors.gray200,
  },
  cuenta_archivada: {
    bg: colors.gray100,
    text: colors.gray400,
    border: colors.gray200,
  },

  // Asambleas: estado de la asamblea, entrega de la citación y asistencia
  convocada: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  finalizada: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  asm_enviado: { bg: colors.infoLight, text: colors.infoDark, border: "#93c5fd" },
  asm_entregado: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  asm_leido: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  asm_fallido: { bg: colors.errorLight, text: colors.errorDark, border: "#fecaca" },
  asm_omitido: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  asm_en_mano_pendiente: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
  asm_en_mano_entregada: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  asiste: { bg: colors.successLight, text: colors.successDark, border: "#86efac" },
  no_asiste: { bg: colors.gray100, text: colors.gray600, border: colors.gray200 },
  sin_respuesta: { bg: colors.warningLight, text: colors.warningDark, border: "#fcd34d" },
};

/**
 * Devuelve el estilo de badge para un estado dado.
 * @param {string} status - El estado (case-insensitive, acepta espacios y tildes)
 * @returns {{ bg: string, text: string, border: string }}
 */
export const getStatusStyle = (status) => {
  if (!status) return STATUS_COLORS.pendiente;
  const key = status
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[áà]/g, "a")
    .replace(/[éè]/g, "e")
    .replace(/[íì]/g, "i")
    .replace(/[óò]/g, "o")
    .replace(/[úù]/g, "u");
  return STATUS_COLORS[key] || STATUS_COLORS.pendiente;
};

/**
 * Labels en español para mostrar estados.
 */
export const STATUS_LABELS = {
  trabajando: "Trabajando",
  esperando_ok: "Esperando OK",
  libre: "Libre",
  presupuesto_agotado: "Presupuesto agotado",
  aplicado: "Aplicado",
  dry_run: "Dry-run",
  rechazado_por_limite: "Fuera de límite",
  descartado: "Descartado",
  error: "Error",
  reportada: "Reportada",
  pendiente: "Pendiente",
  abierta: "Abierta",
  en_proceso: "En Proceso",
  respondida: "Respondida",
  resuelta: "Resuelta",
  cancelada: "Cancelada",
  cerrada: "Cerrada",
  pagado: "Pagado",
  pagada: "Pagada",
  impago: "Impago",
  pendiente_verificacion: "Pendiente verificación",
  aprobado: "Aprobado",
  aprobada: "Aprobada",
  rechazado: "Rechazado",
  rechazada: "Rechazada",
  al_dia: "Al día",
  en_deuda: "En deuda",
  ph_en_tramite: "PH en trámite",
  ph_incorporado: "PH incorporado",
  comun: "Padrón común",
  vivienda_promovida: "Vivienda Promovida",
  sin_contactar: "Sin contactar",
  contactado: "Contactado",
  en_conversacion: "En conversación",
  reunion: "Reunión agendada",
  propuesta: "Propuesta enviada",
  ganado: "Ganado",
  perdido: "Perdido",
  descartado: "Descartado",
  planificado: "Planificado",
  en_progreso: "En Progreso",
  en_curso: "En Curso",
  finalizado: "Finalizado",
  programada: "Programada",
  pausado: "Pausado",
  activa: "Activa",
  anulada: "Anulada",
  incluida_en_cierre: "Incluida en cierre",
  completada: "Completada",
  alta: "Alta",
  media: "Media",
  baja: "Baja",
  presente: "Presente",
  ausente: "Ausente",
  regular: "Regular",
  extra: "Extra",
  feriado: "Feriado",
  propietario: "Propietario",
  inquilino: "Inquilino",
  borrador: "Borrador",
  emitido: "Emitido",
  critico: "Crítico",
  atencion: "Atención",
  normal: "Normal",
  enviada: "Enviada",
  cuenta_activa: "Activa",
  cuenta_invitada: "Invitada",
  cuenta_vencida: "Vencida",
  cuenta_sin_enviar: "Sin enviar",
  cuenta_archivada: "Archivada",
  completo: "Completo",
  parcial: "Parcial",
  inferido: "Inferido",
  convocada: "Convocada",
  finalizada: "Finalizada",
  asm_enviado: "Enviada",
  asm_entregado: "Entregada",
  asm_leido: "Leída",
  asm_fallido: "Falló el envío",
  asm_omitido: "Sin enviar",
  asm_en_mano_pendiente: "Entregar en mano",
  asm_en_mano_entregada: "Entregada en mano",
  asiste: "Asiste",
  no_asiste: "No asiste",
  sin_respuesta: "Sin respuesta",
};
